import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { PAUSE_ACTION_MESSAGE } from './const';
import { isFunction } from '@cp/src/utils/commonUtils';
import { Dispatch } from '@reduxjs/toolkit';
import { setCaseDetail } from '../../reducers/caseDetailSlice';
import { STORE_KEYS } from '../../constants';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

export const getLanPauseStatus = async (caseId: string, caseBusinessVertical: string) => {
  try {
    const url = getApiUrl(ApiKeys.GET_PAUSE_STATUS, { caseId });
    const response = await axiosInstance.get(url, { headers: { caseBusinessVertical } });
    return response?.data;
  } catch (error) {
    return logError(error);
  }
};

export const getPauseDate =
  (lan: string, customerID: string, caseId: string, caseBusinessVertical: string) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_PAUSE_STATUS, { caseId });
    axiosInstance.get(url, { headers: { caseBusinessVertical } }).then(response => {
      dispatch(
        setCaseDetail({
          lan,
          customerRefrenceId: customerID,
          key: STORE_KEYS.PAUSE_STATUS,
          data: response.data
        })
      );
    });
  };

interface PauseActionInput {
  caseId: string;
  payload: any;
  setLoading: (loading: boolean) => void;
  successCallback: () => void;
}

export const submitPauseAction = ({
  caseId,
  payload,
  setLoading,
  successCallback
}: PauseActionInput) => {
  const url = getApiUrl(ApiKeys.PAUSE_ACTION, { caseId });

  if (isFunction(setLoading)) setLoading(true);

  axiosInstance
    .post(url, payload)
    .then(() => {
      toast.success(PAUSE_ACTION_MESSAGE.COLLECTIONS_PAUSED);
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SNOOZE_EFFORTS_UPDATED, {
        caseId,
        reason: payload.pauseEffortsReason,
        pauseEffortsTillDate: payload.pauseEffortsTillDate
      });
      successCallback();
    })
    .catch(error => {
      toast.error(PAUSE_ACTION_MESSAGE.FAILED_TO_PAUSE);
      logError(error);
    })
    .finally(() => {
      isFunction(setLoading) && setLoading(false);
    });
};
